import React from 'react';
import type { AttentionItemWorkContextMembership } from '../../domain/radarThreads';

export interface WorkContextChipProps {
  membership: AttentionItemWorkContextMembership;
  onNavigate?: () => void;
}

/**
 * Compact affiliation chip for source tabs (Jira / GitHub / Slack).
 * Shown only for consolidated work contexts (multi-member or manual hub).
 */
export const WorkContextChip: React.FC<WorkContextChipProps> = ({ membership, onNavigate }) => {
  if (!membership.isConsolidated) return null;
  const label = membership.isManual ? membership.title : membership.key;

  return (
    <span
      data-testid="work-context-chip"
      role={onNavigate ? 'button' : undefined}
      tabIndex={onNavigate ? 0 : undefined}
      onClick={
        onNavigate
          ? (e) => {
              e.stopPropagation();
              onNavigate();
            }
          : undefined
      }
      onKeyDown={
        onNavigate
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                onNavigate();
              }
            }
          : undefined
      }
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 999,
        cursor: onNavigate ? 'pointer' : 'default',
        background: 'var(--z-accent-wash)',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 10.5,
        fontWeight: 700,
        color: 'var(--z-accent-ink)',
      }}
      title={`Contexto: ${membership.title}`}
    >
      Contexto · {label}
    </span>
  );
};
